/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  deleteContactInbox() {
    return axios.post(`${this.url}/delete_last_contact_inbox`);
  }

  fetchAttachementByConversationId(conversationID) {
    return axios.get(`${this.url}/${conversationID}/conversation_attachments`);
  }
  fetchSummaryByConversationId(conversationID) {
    return axios.get(`${this.url}/${conversationID}/conversation_summaries`);
  }
}

export default new ConversationApi();
